import { IProps } from '@/Interfaces/Icons/Props.interface';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const PulseHeadsetIcon = ({ className, width = '24' }: IProps) => {
  return (
    <svg
      className={classNames('pulse-headset-icon', className)}
      width={width}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12V13'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <rect x='2' y='12' width='4' height='7' rx='2' fill='currentColor' />
      <rect x='18' y='12' width='4' height='7' rx='2' fill='currentColor' />
      <path
        d='M9 14L10 12L11 15L12 11L13 16L14 13L15 14'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

PulseHeadsetIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
};

export default PulseHeadsetIcon;
